import { GuestLink } from "../../types/GuestLink";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import ROUTES from "../../configs/routesConfig";
import { Row } from "antd";
import { useSelector } from "react-redux";

export const UsefulLinks = () => {
  const metaData = useSelector((state: any) => state.metaData);

  const links: GuestLink[] = useMemo(
    () => [
      {
        title: "Forgot password",
        to: ROUTES.FORGOT_PASSWORD,
      },
      {
        title: "Forgot email/username",
        to: ROUTES.FORGOT_ACCOUNT,
      },
    ],
    [],
  );

  return (
    <>
      <Row className="useful-links__container mt-12 justify-space-between">
        <Row className="flex-column align-start">
          {links.map((link) => (
            <Link
              className="pa-0 ant-btn-link mb-2"
              to={link.to || "#"}
              key={link.title}
            >
              {link.title}
            </Link>
          ))}
        </Row>
        {metaData.featureFlags?.OnlineAccess && (
          <Row className="no-account__container justify-center">
            <span>New to the service?</span>
            <Link className="h-unset pl-2 ant-btn-link" to={ROUTES.SIGN_UP}>
              Sign Up
            </Link>
          </Row>
        )}
      </Row>
    </>
  );
};
